const data = [
  {
    img: "images/eventImg1.jpg",
    title: "Mission for Fresh & clean Water",
    time: "08 to 10PM",
    date: "12 Dec",
    location: "Jordan house, Bafelo",
  },
  {
    img: "images/eventImg2.jpg",
    title: "Education for poor children",
    time: "05 to 11PM",
    date: "14 Dec",
    location: "Jordan house, new York",
  },
  {
    img: "images/eventImg3.jpg",
    title: "Education for street children",
    time: "10 to 12PM",
    date: "15 Dec",
    location: "Jordan house, Canada",
  },
  {
    img: "images/eventImg4.jpg",
    title: "Rights for poor children",
    time: "01 to 10PM",
    date: "16 Dec",
    location: "Jordan house, Jorzia",
  },
  {
    img: "images/eventImg5.jpg",
    title: "Education for poor children",
    time: "08 to 10AM",
    date: "17 Dec",
    location: "New York City, Montaria",
  },
  {
    img: "images/eventImg6.jpg",
    title: "Education for poor children",
    time: "08 to 10PM",
    date: "23 Dec",
    location: "Jordan house, India",
  },
];
export default data;
